import { segment } from '@actions/analytics';
import { toggleSiteWideReferralBanner } from '@actions/auth';
import {
  REFERRAL_PLAYER_DIALOG,
  REFERRAL_TOUCHPOINT_CLICKED,
  REFERRAL_TOUCHPOINT_CLOSED
} from '@constants/segment';
import pushRoute from '@utils/pushRoute';
import cookies from './cookies';

export const hideReferrals = (dispatch, lpss, onReferNowClick) => {
  dispatch(toggleSiteWideReferralBanner());
  if (!onReferNowClick) {
    segment.track(REFERRAL_TOUCHPOINT_CLOSED, { last_primary_source: lpss });
  }
  cookies.setCookie('referral-banners', {
    date: new Date().getTime(),
    isFirstSevenDays: !cookies.readCookie('referral-banners') || false,
    dontshow: true
  });
};

export const gotoReferralPage = (goalInfo, lpss, dispatch) => {
  segment.track(REFERRAL_TOUCHPOINT_CLICKED, { last_primary_source: lpss });
  if (lpss !== REFERRAL_PLAYER_DIALOG) {
    hideReferrals(dispatch, lpss, true);
  }
  if (!goalInfo) {
    pushRoute('/settings', '/settings');
  } else {
    pushRoute(
      '/goal/[goalSlug]/[goalUID]/referral',
      `/goal/${goalInfo.slug}/${goalInfo.uid}/referral`
    );
  }
};

export const checkShowReferrals = () => {
  const referralCookie = cookies.readCookie('referral-banners')
    ? JSON.parse(cookies.readCookie('referral-banners'))
    : null;
  if (!referralCookie) return true;
  const daysDifference = Math.round(
    (new Date() - new Date(referralCookie.date)) / (1000 * 3600 * 24)
  );
  if (referralCookie.isFirstSevenDays && daysDifference > 7) {
    cookies.setCookie('referral-banners', {
      date: new Date().getTime(),
      isFirstSevenDays: false,
      dontshow: false
    });
    return true;
  }
  if (!referralCookie.isFirstSevenDays) {
    if (referralCookie.dontshow && daysDifference > 7) {
      cookies.setCookie('referral-banners', {
        date: new Date().getTime(),
        isFirstSevenDays: false,
        dontshow: false
      });
      return true;
    }
    if (!referralCookie.dontshow && daysDifference > 2) {
      cookies.setCookie('referral-banners', {
        date: new Date().getTime(),
        isFirstSevenDays: false,
        dontshow: false
      });
      return true;
    }
  }
  return false;
};

export default { gotoReferralPage, hideReferrals };
